import type React from "react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@planta-v2/pds-ui/dialog";
import { i18n } from "@frontend/i18n";

export interface ProfilePhotoPreviewModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly photoUrl: string;
  readonly displayName: string;
}

export function ProfilePhotoPreviewModal({
  isOpen,
  onClose,
  photoUrl,
  displayName,
}: ProfilePhotoPreviewModalProps): React.JSX.Element {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      {/* The image IS the surface here, so no card treatment; the scrim is 80%
          black rather than the default 50% to sit the photo on near-darkness. */}
      <DialogContent
        data-testid="profile-photo-preview-modal"
        overlayClassName="bg-black/80"
        surface={false}
        showCloseButton={false}
      >
        <DialogTitle className="sr-only">{displayName}</DialogTitle>
        <DialogDescription className="sr-only">
          {i18n.t("participantProfile.photo.closePreview")}
        </DialogDescription>
        <DialogClose asChild>
          <button
            type="button"
            data-testid="profile-photo-preview-image"
            aria-label={i18n.t("participantProfile.photo.closePreview")}
            className="cursor-pointer bg-transparent border-none p-0 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black"
          >
            <img
              src={photoUrl}
              alt={displayName}
              className="max-h-[80dvh] max-w-[90vw] object-contain rounded-lg"
            />
          </button>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
}
